module.exports = ".form-checkbox[type=\"radio\"]:not(:checked), [type=\"radio\"]:checked{\r\n\tposition: unset;\r\n\tleft: unset;\r\n}"